import { IWTButton } from '../IWTButton';

export const GiftMembershipIWT = () => {
  const giftMembershipLink =
    'https://www.ace.aaa.com/membership/membership-options/gift-membership.html?intcmp=nav:becomeamember:giftmembership';
  return (
    <IWTButton
      title="Gift a membership"
      id="GiftMembershipIWT"
      onClick={() => {
        window.open(giftMembershipLink);
      }}
    />
  );
};
